/** Events that must survive replacement of an obsolete observation. Movement
 * and combat effects expire; chat, results and action receipts do not. */
export function retainRecoveryEvent(event: unknown): boolean {
  if (!event || typeof event !== "object" || !("type" in event)) return false;
  return event.type !== "moved" && event.type !== "combat-hit" &&
    event.type !== "combat-miss" && event.type !== "combat-block" &&
    event.type !== "vortex" && event.type !== "blink" && event.type !== "telegrab";
}
